module.exports = __webpack_public_path__ + "static/img/p2.0ef1ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productimg/p2.png
// module id = JI4j
// module chunks = 0